export type { FaqServiceSupportProps } from './faq-service-support';
export * from './faq-service-support.routes';

export { default as FaqServiceSupport, default } from './faq-service-support';
